import { PATH_DASHBOARD } from "../routes/paths";

export function getClientProfileWithTradeRoute(role, clientId) {
  switch (role) {
    case 'superAdmin': return PATH_DASHBOARD.client.view(clientId);
    case 'broker': return PATH_DASHBOARD.operatorRole.clients.view(clientId);
    case 'admin': return PATH_DASHBOARD.insurerRole.client.view(clientId);
    default: return '/404'; // fallback route
  }
}